module.exports = __webpack_public_path__ + "img/thumbnail_TamworthPig_j_normal.10bc8989.png";